var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198.219,
    height: 40,
    viewBox: "0 0 198.219 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6175",
    "data-name": "Rectangle 6175",
    width: 198.219,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-206.435 -475.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50331",
    "data-name": "Group 50331",
    transform: "translate(206.435 475.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50329",
    "data-name": "Group 50329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50328",
    "data-name": "Group 50328",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69774",
    "data-name": "Path 69774",
    d: "M100.1,23.566v.878a11.7,11.7,0,1,1-11.7-11.7h.878v5.668H88.4a6.031,6.031,0,1,0,6.031,6.031v-.878Zm10.8-10.119h-5.732V35.441h14.017V30.276H110.9Zm19.5,0h-5.732V35.441H130.4Zm23.115,10.119v.878a6.03,6.03,0,1,1-6.03-6.031h.878V12.746h-.878a11.7,11.7,0,1,0,11.7,11.7v-.878Zm31.724,11.875-8.8-11.53L184,13.447h-6.665l-7.265,9.964V13.447H164.34V35.441h5.732V24.477l8.365,10.964Zm11.393-21.994H190.9V35.441h5.732Zm24.656,0H202.356v5.166h6.6V35.441h5.732V18.612h6.6Z",
    transform: "translate(-23.066 -3.833)",
    fill: "#002148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69775",
    "data-name": "Path 69775",
    d: "M33.2,20H40A20,20,0,1,1,20,0V6.8A13.2,13.2,0,1,0,33.2,20",
    transform: "translate(0 0)",
    fill: "#002148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69776",
    "data-name": "Path 69776",
    d: "M42.764,5.425,28.72,27.332a3.172,3.172,0,0,1-5.294.071l-.017-.027L17.42,18.282c-.86-1.28,2.443-5.792,3.34-4.667l5.258,6.537S41.518,2.31,42.334,2.941a1.876,1.876,0,0,1,.43,2.485",
    transform: "translate(-5.196 -0.88)",
    fill: "#5396ce"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickit);
export default __webpack_public_path__ + "static/media/clickit.d715cc9574c28d60672c566a20ecc4ff.svg";
export { ForwardRef as ReactComponent };